import { useEffect } from 'react';

interface SEOSchemaProps {
  type: 'website' | 'organization';
}

export default function SEOSchema({ type }: SEOSchemaProps) {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    // Remove existing schema if any
    const existingSchema = document.querySelector('script[data-schema-type]');
    if (existingSchema) {
      existingSchema.remove();
    }

    const schema = type === 'website' ? {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "EasyTravel",
      "url": siteUrl,
      "description": "Platform voor onafhankelijke regie in groepsvervoer voor gemeenten en vervoersbedrijven in Nederland",
      "potentialAction": {
        "@type": "SearchAction",
        "target": {
          "@type": "EntryPoint",
          "urlTemplate": `${siteUrl}/?s={search_term_string}`
        },
        "query-input": "required name=search_term_string"
      }
    } : {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "EasyTravel",
      "url": siteUrl,
      "logo": "https://static.readdy.ai/image/9bbaefa2db83d27f3b99b300a515e0ca/030dfe57d5d838db27faa02dd2828490.png",
      "description": "EasyTravel biedt een krachtig platform voor groepsvervoer met 24/7 realtime data, onafhankelijk van elke vervoerder",
      "address": {
        "@type": "PostalAddress",
        "addressCountry": "NL"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "contactType": "customer service",
        "availableLanguage": ["nl"]
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-schema-type', type);
    script.textContent = JSON.stringify(schema);
    document.head.appendChild(script);

    return () => {
      const schemaScript = document.querySelector('script[data-schema-type]');
      if (schemaScript) {
        schemaScript.remove();
      }
    };
  }, [type]);

  return null;
}
